import * as React from 'react';
import styled from 'styled-components';
import { ResponsiveTypography } from '@doltech/ui/lib/figma/Typography/v3/ResponsiveTypography';

const Container = styled.div``;

interface TooltipContentProps {
  title?: string;
  description?: string;
}

export const TooltipContent = (props: TooltipContentProps) => {
  const { title, description } = props;

  return (
    <Container className="tooltip-content">
      <ResponsiveTypography.Paragraph variant="regular/14-20" color="gray180" mb="4px">
        {title}
      </ResponsiveTypography.Paragraph>
      <ResponsiveTypography.Paragraph variant="regular/12-16" color="gray100">
        {description}
      </ResponsiveTypography.Paragraph>
    </Container>
  );
};
